<template>

  <v-container fluid v-if="rooms">

    <im-page-title
      title="Camere"
    />

    <im-rooms-tool
      @create="goToCreate()"
    />

    <im-rooms-list
      :rooms="rooms"
      @edit="goToEdit($event)"
      @list="getRooms($event)"
    />

  </v-container>

</template>


<script>

  import room_repository from '@/repositories/room-repository';

  export default {

    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-rooms-tool': () => import('@/components/Room/RoomToolbar'),
      'im-rooms-list': () => import('@/components/Room/RoomList')
    },

    data: () => ({
      rooms: null,
    }),

    async created() {
      this.rooms = await this.getRooms();
    },

    methods: {

      async getRooms(pagination) {
        return room_repository.getRooms(this.$route.params.hotel, pagination || {size: 10, page: 1});
      },

      goToCreate() {
        this.$router.push(`/hotels/${this.$route.params.hotel}/rooms/create`);
      },

      goToEdit(room) {
        this.$router.push(`/hotels/${this.$route.params.hotel}/rooms/${room.id}`);
      }

    }

  }

</script>